import {
  GET_ORDER_BY_ID_REQUEST,
  GET_ORDER_BY_ID_SUCCESS,
  GET_ORDER_BY_ID_FAILURE,
  GET_ORDER_ADDRESSES_REQUEST,
  GET_ORDER_ADDRESSES_SUCCESS,
  GET_ORDER_ADDRESSES_FAILURE,
  LOG_OUT_SUCCESS,
} from '../../constants/ActionTypes'
import * as errMessages from '../../constants/ErrorMessages';
import { formatErrorMessage } from '../../utils/utils'
const { OrderedMap } = require("immutable");

const initialState = {
  orderId: null,
  order: null,
  isOrderLoading: false,
  orderAddresses: OrderedMap({}),
  isLoadingOrderAddresses: false,
  shortMessage: "",
  message: "",
  errorMessage: "",
  pageInfo: null,
};

export default (state = initialState, action) => {
  state = {
    ...state,
    shortMessage: "",
    successMessage: "",
    errorMessage: "",
  };

  let list;

  switch (action.type) {
    case GET_ORDER_BY_ID_REQUEST:
      return {
        ...state,
        isOrderLoading: true,
        orderId: action.payload.id,
        order: null,
      };
    case GET_ORDER_BY_ID_SUCCESS:
      if (
        state.orderId.toString() === action.payload.data.id.toString()
      ) {
        return {
          ...state,
          isOrderLoading: false,
          order: action.payload.data,
        };
      } else {
        return state;
      }
    case GET_ORDER_BY_ID_FAILURE:
      return {
        ...state,
        isOrderLoading: false,
        errorMessage: formatErrorMessage(
          action.payload.error,
          errMessages.ERR_GET_FAILURE
        ),
      };
    case GET_ORDER_ADDRESSES_REQUEST:
      return {
        ...state,
        isLoadingOrderAddresses: true,
        orderAddresses: action.payload.overwrite
          ? OrderedMap({})
          : state.orderAddresses,
      };
    case GET_ORDER_ADDRESSES_SUCCESS:
      list = OrderedMap({});
      action.payload.addresses.forEach((item) => {
        list = list.set(item.id, item);
      });

      return {
        ...state,
        isLoadingOrderAddresses: false,
        orderAddresses: list,
        pageInfo: action.payload.pageInfo,
      };
    case GET_ORDER_ADDRESSES_FAILURE:
      return {
        ...state,
        isLoadingOrderAddresses: false,
        errorMessage: formatErrorMessage(
          action.payload.error,
          errMessages.ERR_GET_FAILURE
        ),
      };
    case LOG_OUT_SUCCESS:
      return initialState;
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/reducers/orderDetail.js